import { legacyAdapter } from './legacyAdapter'
import { superstoryAdapter } from './superstory'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

export const adaptBrandEvent = loadBrandConfig({
  rocnovel: legacyAdapter,
  oceread: legacyAdapter,
  ficmoon: legacyAdapter,
  storyella: legacyAdapter,
  aurenovel: legacyAdapter,
  florastory: legacyAdapter,
  silktale: legacyAdapter,
  freefic: legacyAdapter,
  pearla: legacyAdapter,
  fictora: legacyAdapter,
  marinovel: legacyAdapter,
  talewave: legacyAdapter,
  moonpage: legacyAdapter,
  novelune: legacyAdapter,
  storlyn: legacyAdapter,
  novaris: legacyAdapter,
  novelyn: legacyAdapter,
  flipnovel: legacyAdapter,
  novelarc: legacyAdapter,
  novelsprig: legacyAdapter,
  novelmello: legacyAdapter,
  superstory: superstoryAdapter,
})
